export default __webpack_public_path__ + "static/media/heart.5a1130b5.svg";